import { Api } from 'utils';

class GlobalNotificationService {
		
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/global-notifications/',params),
		send: async (params?: any) => Api.createResponse('admin/global-notifications/send',params),
		getTypes: async (params?: any) => Api.createResponse('admin/global-notifications/types',params),
		getSanes: async (params?: any) => Api.createResponse('admin/global-notifications/sanes',params),
	}

}

export default GlobalNotificationService;